/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-19 16:51:20
 * @LastEditTime: 2019-07-24 14:37:31
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

//  订单列表新增接口Url
const saveStorageOrderUrl = '/manage/storage/saveStorageOrder'

//  根据userId查询企业信息
const findByUserIdAndCompanyNameUrl = '/authentication/get'

// 订单列表新增接口
export function saveStorageOrder(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + saveStorageOrderUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'saveStorageOrder'
      }, param))
    }
  })
}

// 根据userId查询企业信息
  export function findByUserIdAndCompanyName(param) {
    return logistice({
      url: LOGISTICE_GATEWAY + findByUserIdAndCompanyNameUrl,
      method: 'post',
      params: {
        params: JSON.stringify(Object.assign({
          methodName: 'findByUserIdAndCompanyName'
        }, param))
      }
    })
  }

/* 查询字典接口 */
const getDictUrl = `/sys/dict/getDict`

// 获取字典接口
export function getDict(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getDictUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getListByType',
        type: param,
        hasAll: 'no'
      }, {}))
    }
  })
}
